import { useLocation } from 'react-router-dom';


import './Menu.css'
import logo from '../../static/img/logo.jpg'

const HeaderNA = ({ setChatType }) => {
    const location = useLocation();
    // console.log('location.pathname', location.pathname)
    const navigateToMain = () => {
        window.location.href = 'https://bottax.tech'; 
    };

    return (
        <header style={{ backgroundColor: 'black', padding: '10px' }}>
            <div className='header_menu'>
                <div onClick={() => navigateToMain()}>
                    <img src={logo} className='header_logo' alt='logo'/>
                </div>

            </div>
        </header>
    );
};

export default HeaderNA;
